import React from 'react'
import StructuredData from './StructuredData'

export const getAudienceData = (audienceType) => {
  return {
    '@type': 'Audience',
    audienceType,
  }
}

export default function AudienceStructuredData({ data }) {
  if (!data) return null
  const structuredData = getAudienceData(data)
  return <StructuredData data={structuredData} dataTestId="audience-structured-data" />
}
